import { callApi } from "./fetchTools";
import { HTTP_METHOD_GET, HTTP_METHOD_POST } from "../utils/constant";
import apis from "../common/apis";
import { ICategory } from "../models/categoryModel";

export default {
  getCategories: (query: any) => {
    return callApi<ICategory[]>(HTTP_METHOD_GET, apis.category, query);
  },
  getMenuCategories: (query: any) => {
    return callApi<any>(HTTP_METHOD_GET, apis.menu_categories, query);
  },
  getBannersCategory: (query: any) => {
    return callApi<any>(HTTP_METHOD_POST, apis.banner_category, query);
  },
};
